const partyTrends = {
  en: {
    partyTrendsPage: {
      title: "Party Performance Trends",
      subtitle: "Track party performance over time",
      filterPlaceholder: "Filter by party",
      allParties: "All Parties",
      refresh: "Refresh",
      councilsDecided: "Councils Decided",
      partiesCompeting: "Parties Competing",
      daysOfReporting: "Days of Reporting",
      leadingParty: "Leading Party",
      na: "N/A",
      cumulativeTitle: "Cumulative Councils Won Over Time",
      cumulativeDesc: "How party wins have accumulated as results come in",
      noTrend: "No trend data available yet",
      rankings: "Party Rankings",
      rankingsDesc: "By councils won nationwide",
      noData: "No data",
      regionalPerformance: "Regional Performance",
      winsByRegion: "{{party}} wins by region",
      noRegional: "No regional data",
      timelineTitle: "Daily Results Timeline",
      timelineDesc: "Number of councils reporting each day",
      councilsReported: "Councils Reported",
      noTimeline: "No timeline data"
    }
  },
  fr: {
    partyTrendsPage: {
      title: "Tendances de performance des partis",
      subtitle: "Suivez la performance des partis dans le temps",
      filterPlaceholder: "Filtrer par parti",
      allParties: "Tous les partis",
      refresh: "Actualiser",
      councilsDecided: "Communes attribuées",
      partiesCompeting: "Partis en compétition",
      daysOfReporting: "Jours de remontée des résultats",
      leadingParty: "Parti en tête",
      na: "N/D",
      cumulativeTitle: "Communes remportées cumulées dans le temps",
      cumulativeDesc: "Évolution cumulée des victoires des partis au fil des résultats",
      noTrend: "Aucune donnée de tendance disponible pour le moment",
      rankings: "Classement des partis",
      rankingsDesc: "Par communes remportées à l'échelle nationale",
      noData: "Aucune donnée",
      regionalPerformance: "Performance régionale",
      winsByRegion: "Victoires de {{party}} par région",
      noRegional: "Aucune donnée régionale",
      timelineTitle: "Chronologie quotidienne des résultats",
      timelineDesc: "Nombre de communes ayant transmis leurs résultats chaque jour",
      councilsReported: "Communes ayant transmis",
      noTimeline: "Aucune donnée chronologique"
    }
  }
};

export default partyTrends;
